module.exports = __webpack_public_path__ + "static/pic16-07796c17ec7d3828fcd6af91cda97547.jpg";